import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectIsInAppWrapper, selectLocale } from '@/store/selectors/commonSelectors';
import { isMobile } from 'react-device-detect';
import { envIsCanada, envIsNormal } from '@/constants/constants';
import { isRegulatedLocale } from '@/shared/utility';

export const useInjectSmartBannerScript = () => {
  const locale = useSelector(selectLocale);
  const isInAppWrapper = useSelector(selectIsInAppWrapper);
  const initialized = useRef<boolean | null>(null);

  useEffect(() => {
    if (initialized.current) {
      console.log('AppsFlyer already initialized (via ref).');
      return;
    }

    if (window.AF) {
      console.log('AppsFlyer already present on window.');
      initialized.current = true;
      return;
    }

    if (!isMobile || isInAppWrapper) {
      return;
    }

    let key;

    if (envIsCanada()) {
      key = 'f19243f0-826c-47ed-a694-d80fd64d87fd';
    }

    if (envIsNormal() && !isRegulatedLocale(locale)) {
      if (locale === 'th') {
        key = 'fb7abfeb-f9e6-4d4d-9fff-fd9daff0842c';
      }
      if (locale === 'at') {
        key = '17fb7820-719d-4b49-a5ef-16ee58920525';
      }
      if (['ca', 'ca-fr'].includes(locale)) {
        key = '64550c35-8293-4bac-9b67-9cbeb2f224f9';
      }
      key = '4416b76a-085f-4bfb-8d0a-31827eed5093';
    }

    if (!key) {
      return;
    }

    const script = document.createElement('script');
    script.innerHTML = `
    !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${key}"}});
    AF('banners', 'showBanner')
      `;

    document.body.appendChild(script);
    initialized.current = true;

    return () => {
      document.body.removeChild(script);
    };
  }, [locale, isInAppWrapper]);
};
